/**
 * Referral source, e.g. `?source=card`.
 *
 * Used so James can tell roughly where people arrived from — a card handed
 * over in person versus a link shared on. It is a short opaque label from a
 * fixed allow-list, not an identifier, and it is not tied to a person.
 */

const SESSION_KEY = 'awc.source';

/** Anything not on this list is discarded rather than stored. */
const ALLOWED = new Set(['card', 'qr', 'link', 'direct']);

/**
 * Reads `?source=` once and remembers it for the tab, so that the label
 * survives navigating from the profile into the journey. sessionStorage, not
 * localStorage: it is gone when the tab closes.
 */
export function captureSource(search: string): string | null {
  try {
    const fromUrl = new URLSearchParams(search).get('source')?.toLowerCase().trim();
    if (fromUrl && ALLOWED.has(fromUrl)) {
      sessionStorage.setItem(SESSION_KEY, fromUrl);
      return fromUrl;
    }
    return sessionStorage.getItem(SESSION_KEY);
  } catch {
    // Private browsing modes can throw on storage access.
    return null;
  }
}

export function getSource(): string | null {
  try {
    return sessionStorage.getItem(SESSION_KEY);
  } catch {
    return null;
  }
}
